import React from 'react';
import $ from 'jquery';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';

import {
    Button,
} from 'react-bootstrap';

export default class SubmitButton extends React.Component {

    constructor(props){
        super(props);
        this.state = {redirect: false, cookie: '', redirect_url:''};
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          this.handleSubmitClick();
        }
    }

    getCookie = (c_name) => {
        // console.log('document.cookie.length: ' + String(document.cookie.length));
        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            return "";
        }
    }

    handleSubmitClick = () => {
        let editingInstance = this.props.editingInstance;
        let p = this.props.ignored_fields_with_values;
        for (var key in p) {
          editingInstance[key] = p[key]
        }
        let cookie = this.getCookie('csrftoken');
        if (this.props.add_csrf_cookie === true) {
            editingInstance['csrfmiddlewaretoken'] = cookie;
        }
        if (this.props.add_csrf_to_header === true) {
          $.ajax({
            headers: {"X-CSRFToken": cookie}
          })
        }
        // console.log('submitButton editingInstance');
        // console.log(editingInstance);
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            method: 'POST',
            data: editingInstance,
            cache: false,
            statusCode: {
               403: () => {
                 this.setState({redirect_url: '/login/', redirect: true})
               }
            },
            success: (data) => {
              this.setState({redirect: true, redirect_url:this.props.redirect_url})
              this.props.clearEditingInstance();
              this.props.setMessage(this.props.success_message, 'success');
            },
            error: (xhr, status, err) => {
              this.setState({redirect_url: this.props.failed_redirect_url, redirect: true})
              this.props.clearEditingInstance();
              // this.props.setMessage(this.props.failed_message, 'danger');
              var error = JSON.parse(xhr.responseText);
              this.props.setMessage(error.detail, 'danger');
            }
        });
    }

    render() {
        if (this.state.redirect === true) {
            return <Redirect to={this.state.redirect_url} />;
        }
        return (
            <Button bsStyle='success' bsSize='large' id="submit_button" onKeyDown={this.handleKeyDown} onClick={() => this.handleSubmitClick()}>Submit</Button>
        );
    }
}

SubmitButton.propTypes = {
    editingInstance: PropTypes.node,
    redirect_url: PropTypes.node,
    message: PropTypes.node,
    ignored_fields_with_values: PropTypes.node,
    button_title: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/button/submit_button.js